import React, { Component } from 'react';
import Summary from "../components/summary/index";

import {observer,inject} from 'mobx-react';

@inject("summaryDataStore")
@observer
class SummaryPage extends Component {

    componentDidMount(){
        // prjId?/:prjId?
        const prjId= this.props.match.params.prjId;
        const plnId = this.props.match.params.plnId;
        this.props.summaryDataStore.getSummary(prjId, plnId);
        this.props.summaryDataStore.resetInstalmentValue();
    }

    render() {
        return (
            <div>
                <Summary />
            </div>
        );
    }
}

export default SummaryPage;



// WEBPACK FOOTER //
// ./src/pages/summary.js